import React, { useContext } from 'react';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';

//mui imports====
import { Box } from '@mui/system';
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Divider, Grid, Paper } from '@mui/material';
//===============

import constants from './constants.json';
import InputConfig from '../../../../Components/InputConfig';

const StopAfterCrossClickConfig = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext
	const commonStyleClasses = useCommonStyles();

	const {
		platforms: { DESKTOP, MOBILE, TABLET }
	} = constants;

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Stop After Cross Click"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Stop After Cross Click']}
				description="Manage Stop After Cross Click Configuration"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>

			<Grid
				container
				spacing={1}
				style={{ width: '97%', marginLeft: '4rem', marginTop: '3rem', width: '90%' }}
			>
				<Grid
					item
					xs={12}
					style={{
						marginBottom: '3rem',
						display: 'flex',
						alignItems: 'center',
						flexDirection: 'row'
					}}
				>
					<Grid item xs={2}>
						<CheckBoxInput
							keyData={keyData + '.enabled'}
							label="enabled"
							disabled={false}
							defaultChecked={false}
							object={rawConfig}
							updateObject={updateRawConfig}
							containerStyles={{ width: 'fit-content' }}
						/>
					</Grid>
					<Grid item xs={5}>
						<CheckBoxInput
							keyData={keyData + '.isSessionLevelEnabled'}
							label="Enable At Session Level"
							disabled={!rawConfig[keyData + '.enabled']}
							defaultChecked={false}
							object={rawConfig}
							updateObject={updateRawConfig}
							containerStyles={{ width: 'fit-content' }}
						/>
					</Grid>
				</Grid>

				<Divider style={{ width: '100%', margin: '2rem 0 3rem' }} />

				<Grid item xs={4}>
					<StopAfterCrossClickConfigPlatformConfig keyData={keyData} title={DESKTOP} />
				</Grid>
				<Grid item xs={4}>
					<StopAfterCrossClickConfigPlatformConfig keyData={keyData} title={MOBILE} />
				</Grid>
				<Grid item xs={4}>
					<StopAfterCrossClickConfigPlatformConfig keyData={keyData} title={TABLET} />
				</Grid>
			</Grid>
		</Paper>
	);
};

const StopAfterCrossClickConfigPlatformConfig = ({ keyData, title }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext

	const updateAdRequestPauseDuration = (val) => {
		const parsedValue = val === '' || isNaN(Number(val)) ? null : Number(val);

		const clonedConfig = structuredClone(rawConfig);
		clonedConfig[keyData + `.platforms.${title}.adRequestPauseDuration`] = parsedValue;

		updateRawConfig(clonedConfig);
	};

	const isTimerToResetEditable =
		!!rawConfig[keyData + '.enabled'] &&
		!!rawConfig[keyData + '.isSessionLevelEnabled'] &&
		!!rawConfig[keyData + `.platforms.${title}.enabled`];

	return (
		<Box className={commonStyleClasses.basicOutlinedBox} style={{ margin: '0rem', width: '90%' }}>
			<Typography fontWeight={600} variant="h4">
				{title}
			</Typography>

			<CheckBoxInput
				keyData={keyData + `.platforms.${title}.enabled`}
				label="enabled"
				disabled={!rawConfig[keyData + '.enabled']}
				defaultChecked={false}
				object={rawConfig}
				updateObject={updateRawConfig}
				containerStyles={{ width: 'fit-content', margin: '2rem 0' }}
			/>
			<InputConfig
				editable={isTimerToResetEditable}
				label="Timer to reset (ms)"
				keyData={keyData + `.platforms.${title}.adRequestPauseDuration`}
				directValue={rawConfig[keyData + `.platforms.${title}.adRequestPauseDuration`] ?? ''}
				isObjectEditor={false}
				updateDirectValue={(val) => {
					updateAdRequestPauseDuration(val);
				}}
			/>
		</Box>
	);
};

export default StopAfterCrossClickConfig;
